import algoliasearch from './algoliasearch-lite.umd.js';
import instantsearch from './instantsearch.production.min.js';
import {autocomplete, getAlgoliaResults} from './autocomplete.production.js';

/* eslint-disable */
export default function AlgoliaInit() {
    const searchClient = algoliasearch(algoliaApp, algoliaApi);

    // Function to initialize Algolia autocomplete for a given container ID
    function initializeAlgoliaAutocomplete(containerId, prefix = null) {
        if (document.getElementById(containerId)) {
            const options = {
                container: `#${containerId}`,
                placeholder: 'Suchbegriff',
                openOnFocus: true,
                insights: false,
                detachedMediaQuery: 'none',
                translations: {
                    clearButtonTitle: 'Leeren',
                    detachedCancelButtonText: 'Abbrechen',
                    submitButtonTitle: 'Absenden',
                },
                classNames: {
                    form: prefix === 'mobile' ? 'header-search-form' : '',
                    input: prefix === 'mobile' ? 'header-search-form__input' : '',
                    submit: prefix === 'mobile' ? 'header-search-form__btn' : '',
                },
                getSources(query) {
                    return [
                        {
                            sourceId: 'querySuggestions',
                            getItemInputValue: ({item}) => item.query,
                            getItems({query}) {
                                return getAlgoliaResults({
                                    searchClient,
                                    queries: [
                                        {
                                            indexName: algoliaIndex,
                                            params: {
                                                query,
                                                ruleContexts: ['enable-redirect-url'],
                                                hitsPerPage: 5,
                                            },
                                        },
                                    ],
                                });
                            },
                            templates: {
                                item({item, components}) {
                                    return item.title ? item.title : item.name;
                                },
                            },
                            onSelect({item, event}) {
                                let targetUrl = item.url;

                                if (targetUrl === '') {
                                    if (item.type === 'pages') {
                                        targetUrl = '/?id=' + item.uid;
                                    } else {
                                        targetUrl = '/?id=' + item.pid;
                                    }
                                }

                                if (item.type === 'sys_file_metadata') {
                                    window.open('/' + item.url, '_blank');
                                } else {
                                    window.location.href = targetUrl;
                                }
                            },
                        },
                        {
                            sourceId: 'fixedLink',
                            getItems() {
                                return [
                                    {
                                        label: 'Alle Ergebnisse ansehen',
                                        url: '/suche',
                                    },
                                ];
                            },
                            getItemUrl({item}) {
                                return item.url;
                            },
                            templates: {
                                item({item, html}) {
                                    return html`<a href="${item.url}" class="aa-ItemLink">${item.label}</a>`;
                                },
                            },
                        },
                    ];
                },
            };

            autocomplete(options);
        }
    }

    const isMobile = window.matchMedia('(max-width: 899px)').matches;

    if (isMobile) {
        initializeAlgoliaAutocomplete('algoliaAutocompleteMobile', 'mobile');
    } else {
        initializeAlgoliaAutocomplete('algoliaAutocomplete', 'desktop');
    }

    if (document.getElementById('algolia__instantsearch')) {
        const search = instantsearch({
            indexName: algoliaIndex,
            searchClient,
        });

        search.addWidgets([
            instantsearch.widgets.searchBox({
                container: '#algolia__searchbox',
                placeholder: 'Suchbegriff',
                showReset: false,
                searchAsYouType: true,
            }),
            instantsearch.widgets.stats({
                container: '#algolia__stats',
                templates: {
                    text: `
                        Suchergebnisse: {{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}}
                      `,
                },
            }),
            instantsearch.widgets.hits({
                container: '#algolia__hits',
                templates: {
                    item: (hit, {html, components}) => {
                        let itemUrl = hit.url,
                            itemTarget = '';

                        if (itemUrl === '') {
                            if (hit.type === 'pages') {
                                itemUrl = '/?id=' + hit.uid;
                            } else {
                                itemUrl = '/?id=' + hit.pid;
                            }
                        }

                        if (hit.type === 'sys_file_metadata') {
                            itemUrl = '/' + hit.url;
                            itemTarget = '_blank';
                        }

                        return html`
                            <a href="${itemUrl}"
                               class="search-result__wrapper"
                               target="${itemTarget}"
                               title="${hit.title}">
                                <h3 class="p-h2 search-result__headline">${hit.title ? components.Highlight({hit, attribute: 'title'}) : components.Highlight({hit, attribute: 'name'})}</h3>
                                <p class="search-result__text">${hit.description ? components.Highlight({hit, attribute: 'description'}) : components.Highlight({hit, attribute: 'alternative'})}</p>
                                <div class="search-result__linktext">Mehr erfahren<span class="arrow">➔</span></div>
                            </a>`
                    }
                }
            }),
            instantsearch.widgets.configure({
                hitsPerPage: 5,
            }),
            instantsearch.widgets.panel({
                templates: {header: 'brand'},
            })(instantsearch.widgets.refinementList)({
                container: '#algolia__brand-list',
                attribute: 'brand',
            }),
            instantsearch.widgets.pagination({
                container: '#algolia__pagination',
                cssClasses: {
                    list: [
                        'pagination__list',
                        'u-list-style-none',
                    ],
                    selectedItem: 'pagination__entry--current',
                    link: [
                        'pagination__entry',
                        'pagination__entry--linked',
                    ],
                },
            }),
        ]);
        search.start();
    }
}
/* eslint-enable */
